import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { AuthenticationProvider } from '@shared/shared/enums/authentication-provider.enum';
import { ISiteListDetails, ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { SiteConfigService } from '@shared/shared/services/site-config.service';
import { USER_SELECTED_SITE } from 'app.config';
import { Observable, combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SiteSetGuard {
  constructor(
    private router: Router,
    private siteSettingsService: SiteSettingsService,
    private siteConfigService: SiteConfigService
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([this.siteSettingsService.fetchSiteSettings(), this.siteConfigService.siteList]).pipe(
      filter(([siteSettings, sites]) => siteSettings?.id && !!sites),
      take(1),
      map(([settings, sites]: [ISiteSettings, ISiteListDetails[]]) => {
        const decommissionedSite = this.siteConfigService.getComponentData('redirectSite')?.default?.sites[0];

        if (decommissionedSite && decommissionedSite.siteId.includes(settings.id)) {
          window.location.href = 'https://travel.mastercard.us';
          return;
        }

        if (
          settings.authentication_provider.provider !== AuthenticationProvider.visa_lac &&
          !localStorage.getItem(USER_SELECTED_SITE) &&
          !window.location.href.includes('auto-login') &&
          !window.location.href.includes('site_id') &&
          sites?.length !== 1
          // TODO: show_country_language_selector_page check can be added here after the switch has been implemented for all sites
        ) {
          const returnUrl = new URLSearchParams(window.location.search).get('returnUrl');

          this.router.navigate(['/selector'], {
            queryParams: { returnUrl: returnUrl !== null ? returnUrl : routerState.url },
          });
        } else {
          if (!route.url?.length) {
            this.router.navigate([]);
            return false;
          }

          const routeUrlPath = route.url[0].path;
          switch (routeUrlPath) {
            case 'home':
              this.router.navigate(['product/homepage'], { queryParamsHandling: 'preserve' });
              break;
            case 'page':
              this.router.navigate([`product/page/${route.params['name']}`], { queryParamsHandling: 'preserve' });
              break;
            case 'activate':
              this.router.navigate([`user/activate/${route.params['id']}`], { queryParamsHandling: 'preserve' });
              break;
            case 'forgot':
              this.router.navigate([`user/forgot/${route.params['id']}`], { queryParamsHandling: 'preserve' });
              break;
            default:
              break;
          }

          return true;
        }
      })
    );
  }
}
